interface ProgressProps {
  count: number;
  target: number;
  indeterminate?: boolean;
  indeterminateWhenZero?: boolean;
}
const Progress = (props: ProgressProps) => {
  const progressProps: any = {
    max: props.target,
  };

  if (!props.indeterminate) {
    if (!(props.count == 0 && props.indeterminateWhenZero)) {
      progressProps.value = props.count;
    }
  }

  return (
    <progress {...progressProps}>
      <span className={"spinner"}></span>
    </progress>
  );
};

export default Progress;
